import {UntypedFormGroup} from '@angular/forms';
import {isNil} from 'lodash-es';

export function canShowErrorForErrorCodeAndFormControlForFormGroup(errorCode: string, formControlName: string, formGroup: UntypedFormGroup): boolean {
  return !isNil(formGroup?.get(formControlName)) && formGroup?.get(formControlName).hasError(errorCode) && formGroup?.get(formControlName).enabled;
}
